import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Transaction } from '../models/transaction';
import { MerchantResponseComponent } from '../merchant-response/merchant-response.component';
import { GlobalAppData } from '../models/global-app-data';
import { environment } from '../../environments/environment';
import { RazorpayTransactionRequest } from '../models/razorpay-payment-details'
import { RazorpayService } from '../services/razorpay.service';
import { LoadingService } from '../services/loading.service';
import { MerchantResponseData } from '../models/merchant-models';
import { SegmentService } from '../services/segment.service';
import { EventTypes } from '../models/enums/event-types';
import { Constants } from '../constants/constants';
import { IndpaystubComponent } from './indpaystub/indpaystub.component';
import { SessionService } from '../services/session.service';
import { firstValueFrom, interval, map, Observable, shareReplay, startWith, takeWhile } from 'rxjs';

declare const Razorpay: any;

@Component({
  selector: 'app-indpay',
  templateUrl: './indpay.component.html',
  styleUrl: './indpay.component.css',
  standalone: false
})
export class IndpayComponent implements OnInit {

  @Input() paymentType: string;
  @Input() contact: string;
  @Input() paymentStatus: string;
  @Input() orderData: Transaction;
  @ViewChild(MerchantResponseComponent) public merchantResponseComponent;
  @ViewChild(IndpaystubComponent) indPayStubComponent;
  razorPayStatus: string;
  timmer: any;
  sessionId: string;
  status: any;
  counter$!: Observable<number>;
  alertEnabled:boolean;
  alertText:string;


  constructor(private translocoSerivce: TranslocoService,
    public gd: GlobalAppData,
    private rzPayService: RazorpayService,
    private _loading: LoadingService,
    private ss: SegmentService,private sessionService: SessionService) {
      this.sessionId = (this.sessionService.sessionId);
  }

  async ngOnInit() {
    const loadScript = document.createElement('script');
    loadScript.src = environment.RAZORPAY_SDK;
    loadScript.async = true;
    loadScript.type = 'text/javascript';
    loadScript.onerror = () => console.error('Failed to load Razorpay'+this.translocoSerivce.getActiveLang());
    window.document.head.appendChild(loadScript);
    await this.initCountdown$();
    this.alertEnabled=this.gd.oscConfig?.indiaAlertEnabled;
    this.alertText=this.gd.oscConfig?.indiaTextAlert;
  }

 private async initCountdown$() {
    this.timmer = this.gd.oscConfig.sessionTimeoutScnds;
    let startSeconds = 0;
    try {
    this.status = await firstValueFrom(this.sessionService.get(this.sessionId));


    startSeconds = Math.max(0, Number(this.status?.balanceTTLInSeconds ?? 0));

    } catch (err) {
      console.error('Failed to load session status', err);
    }

    if (!Number.isFinite(startSeconds) || startSeconds <= 0) {
      const mins = Number(this.timmer ?? 0);
      startSeconds = mins > 0 ? Math.floor(mins * 60) : 0;
    }

   this.counter$ = interval(1000).pipe(
    startWith(0),
      map((ticks) => Math.max(0, startSeconds - ticks - 1)),
      takeWhile((val) => val > 0, true),
      shareReplay({ bufferSize: 1, refCount: true })
    );
    firstValueFrom(this.counter$).then(v => console.log('counter$ first emission (secs):', v));

  }


  formatMMSS(totalSeconds?: number): string {
    const s = Math.max(0, Number(totalSeconds ?? 0));
    const m = Math.floor(s / 60);
    const sec = s % 60;
   return `${m}:${String(sec).padStart(2, '0')}`;
  }


  private initRazorpay(options: any) {
    const rzp = new Razorpay(options);
    this.ss.track(EventTypes.razorPaySubmitted);
    this._loading.setLoading(true, 'internal');
    rzp.open();
  }

  async submitPymntDetail() {
    const timeout =  await firstValueFrom(this.counter$);
    const orderId = this.orderData?.gatewayReferenceId;
    const apiKey =  this.gd.apiKeys?.razorPayKey;
    const rzConfig=this.gd?.oscConfig?.razorpayPaymentConfig===undefined ? {} :JSON.parse(this.gd?.oscConfig?.razorpayPaymentConfig);
    let options = {
      key: apiKey,
      amount: Number(this.orderData?.amountDetail?.baseCurrencyAmount) * 100,
      currency: this.orderData?.amountDetail?.baseCurrencyCode,
      name: "ETS",
      description: "ETS Transaction",
      order_id: orderId,
      config: rzConfig,
      modal: {
        ondismiss: () => {
          this.ss.track(EventTypes.razorPayCancel);
          this.captureFinalResponse(this.getFinalResponseObject(null,true));
          this.handleError();
        }
      },
      timeout:timeout,
      handler: (response: any) => {
        let razorPayReq: any = this.getFinalResponseObject(response,false);
        const reqForService: RazorpayTransactionRequest = {
          ...razorPayReq,
          error: razorPayReq.error ?? null // ensure the property exists
        };
        this.captureFinalResponse(reqForService);
      },
      prefill: {
        name: this.orderData?.shippingAddress?.firstName + " " + this.orderData?.shippingAddress?.lastName,
        email: this.orderData?.shippingContact?.email,
        contact: this.orderData?.shippingContact?.phoneNumber
      },
      notes: {
        address: this.orderData.shippingAddress?.addressLine1 + ", " + this.orderData.shippingAddress?.addressLine2
      },
      theme: {
        color: "#3399cc"
      }
    };
    this.initRazorpay(options);
  }

  private getFinalResponseObject(response: any,isUserCancelled:boolean) {
    let razorPayFinalresponse: any;
    const epmOrderId = this.gd?.orderTransaction?.order?.epmsOrderId || ' ';
    if(isUserCancelled){
      return {
          epmsOrderId: epmOrderId,
          razorpayPaymentId: "",
          razorpayOrderId: "",
          razorpaySignature: "",
          status: Constants.RZ_STATUS_CANCELLED,
          error: {
            code: "203",
            description: "Cancel By user",
            source: "EPMS",
            step: "",
            reason: "payment_cancelled",
            order_id: this.gd?.orderTransaction?.order?.epmsOrderId || ' ',
            payment_id: "",
            field: ""
          }
      };
    }
    razorPayFinalresponse = {
        epmsOrderId: epmOrderId,
        razorpayPaymentId: response.razorpay_payment_id,
        razorpayOrderId: response.razorpay_order_id,
        razorpaySignature: response.razorpay_signature,
        status: null
    };
    if (response.error === undefined || response.error === null) {
      razorPayFinalresponse.status=Constants.RZ_STATUS_SUCCESS
    } else {
      razorPayFinalresponse.status=Constants.RZ_STATUS_ERROR;
    }
    return razorPayFinalresponse;
  }

  captureFinalResponse(reqForService: RazorpayTransactionRequest) {
    this.rzPayService.captureRazorpayFinalResponse(this.orderData.orderTransactionId, reqForService).then(res => {
      this.ss.track(EventTypes.razorPayApproved);
      this.redirectToMerchantSuccessURL();
    }).catch(e => {
      console.log("error occured during saving final response : " + e);
      this.ss.track(EventTypes.razorPayError);
      this.handleError();
    });
  }

  handleError() {
    this.razorPayStatus = 'paymentError';
    this.redirectToMerchantRejectURL();
  }


  redirectToMerchantSuccessURL(): void {
    let merchantSuccessURL = this.gd.orderTransaction.order.merchantSuccessURL;
    if (!merchantSuccessURL) {
      merchantSuccessURL = this.gd.oscConfig.successUrl;
    }
    this.redirectToMerchant(merchantSuccessURL);
  }

  redirectToMerchant(urlVal: string): void {
    sessionStorage.clear()
    const paymentActionData = {
      url: urlVal,
      orderTransaction: this.gd.orderTransaction,
      merchantPaymentReq: {},
    } as MerchantResponseData;
    this.merchantResponseComponent.sendResponseToMerchant('RAZORPAY', paymentActionData);
  }

  redirectToMerchantRejectURL(): void {
    let merchantRejectURL = this.gd.orderTransaction.order.merchantRejectURL;
    if (!merchantRejectURL) {
      merchantRejectURL = this.gd.oscConfig.rejectUrl;
    }
    this.redirectToMerchant(merchantRejectURL);
  }
}
